/* eslint-disable import/prefer-default-export */
import { gql } from 'graphql-request';

export const getPartnersGql = gql`
  query getPartners {
    getPartners {
      partnerName
      partnerUuid
      partnerShortCode
      enabled
      isSuspended
      metaData
      partnerAccount {
        partnerAccountName
        partnerAccountId
      }
      createdTimestamp
      modifiedTimestamp
    }
  }
`;

export const getPartnerPracticesGql = gql`
  query getPartnerPractices($partnerIds: [UUID!]!) {
    getPartnerPractices(partnerIds: $partnerIds) {
      partnerId
      practiceId
      practiceName
      line1
      line2
      city
      state
      zip
    }
  }
`;

export const listPartnerProfilesGql = gql`
  query listPartners($limit: Int, $offset: Int, $filter: PartnerFilter, $sortBy: PartnerSortBy) {
    listPartners(limit: $limit, offset: $offset, filter: $filter, sortBy: $sortBy) {
      count
      result {
        partnerName
        partnerUuid
        partnerShortCode
        createdAt
        updatedAt
        hasApiAccess
        enabled
        clientId
        newProductsActiveByDefault
      }
    }
  }
`;

export const getPartnerWorkflowConfigGql = gql`
  query getLatestPartnerWorkflowConfig($partnerUUID: UUID!) {
    getLatestPartnerWorkflowConfig(partnerUUID: $partnerUUID) {
      partnerWorkflowConfigId
      workflowConfig {
        workflowConfigId
        config
      }
      enabled
    }
  }
`;

export const savePartnerWorkflowConfigGql = gql`
  mutation savePartnerWorkflowConfig($partnerUUID: UUID!, $input: WorkflowConfigInput) {
    savePartnerWorkflowConfig(partnerUUID: $partnerUUID, input: $input) {
      partnerWorkflowConfigId
    }
  }
`;

export const getPartnerCarrierWebhookConfigGql = gql`
  query getPartnerConfig($partnerUuid: UUID!) {
    getPartnerConfig(partnerUuid: $partnerUuid) {
      carrierTrackingWebhookConfig {
        pickedUp
        outForDelivery
        delivered
      }
    }
  }
`;

export const updatePartnerCarrierWebhookConfigGql = gql`
  mutation updatePartnerCarrierTrackingWebhookConfig($input: CarrierTrackingWebhookConfigInput!) {
    updatePartnerCarrierTrackingWebhookConfig(input: $input) {
      pickedUp
      outForDelivery
      delivered
    }
  }
`;

export const addPartnerWithApiAccessGql = gql`
  mutation addPartnerWithApiAccess($input: AddPartnerInput!) {
    addPartnerWithApiAccess(input: $input) {
      partnerUuid
      clientId
      clientSecret
    }
  }
`;

export const getPartnerCatalogGql = gql`
  query getPartnerCatalog($partnerUuid: UUID!, $onlyPartnerEnabled: Boolean) {
    getPartnerCatalog(partnerUuid: $partnerUuid, onlyPartnerEnabled: $onlyPartnerEnabled) {
      drugName
      variants {
        catalogId
        strength
        sigs
        isActive
        isAvailable
        isEnabledByPartner
        compoundingPharmacyId
        productId
        isCompoundingEligible
        packSizeValue
        packSizeUnit
        dosageForm
        formAlias
      }
    }
  }
`;

export const updatePartnerGql = gql`
  mutation UpdatePartner($partnerUuid: String!, $data: UpdatePartnerInput!) {
    updatePartner(partnerUuid: $partnerUuid, data: $data) {
      partnerUuid
      clientId
      clientSecret
    }
  }
`;

export const updatePartnerCatalogStatusGql = gql`
  mutation updatePartnerCatalogStatus($input: UpdatePartnerCatalogStatusInput!) {
    updatePartnerCatalogStatus(input: $input)
  }
`;

export const updatePartnerCatalogGql = gql`
  mutation updatePartnerCatalog($input: UpdatePartnerCatalogInput!) {
    updatePartnerCatalog(input: $input)
  }
`;

export const updatePartnerCatalogDefaultsGql = gql`
  mutation updatePartnerCatalogDefaults($input: UpdatePartnerCatalogDefaultsInput!) {
    updatePartnerCatalogDefaults(input: $input) {
      newProductsActiveByDefault
    }
  }
`;

export const getPartnerOtcCatalogGql = gql`
  query getPartnerOtcCatalog($partnerUuid: UUID!) {
    getPartnerOtcCatalog(partnerUuid: $partnerUuid) {
      catalogId
      isActive
      name
      description
      form
      strength
    }
  }
`;
